module.exports = __webpack_public_path__ + "static/media/p3s2.627e9d60.jpg";